import * as React from 'react'

export const SvgZoomIn = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} fill="none" aria-hidden={true} {...props}>
    <path d="M11 19a8 8 0 100-16 8 8 0 000 16zm10 2l-4.35-4.35M11 8v6m-3-3h6" />
  </svg>
)
export default SvgZoomIn
